import O from "./O";
import Tooltip from '@material-ui/core/Tooltip';

import Navbar from "./Navbar";
import useNavbar from './useNavbar';
import Brightness from './svg/Brightness.svg';
import Contrast from './svg/Contrast.svg';

import { FigureChannelAdjustmentContext } from './Contexts';
import { useContext, useCallback, useState, useEffect, useMemo } from 'react';


const defaults = {
  //min:{ min:0, max:255, defaultValue:0, step:1 },
  //max:{ min:0, max:255, defaultValue:255, step:1 },
  gamma:{ defaultValue: 1, min:0, max:10 },
  contrast:{ defaultValue: 1, min: 0, max: 10 },
  brightness:{ defaultValue: 1, min: 0, max: 10 },
}


const titleMap = {
  brightness:<img style={{width:18}} src={Brightness}/>,
  contrast:<img style={{width:18}} src={Contrast}/>,
  gamma:<div style={{
    //outline:'1px solid blue',
    fontFamily:'Times',fontSize:20,lineHeight:0.7,
    position:'absolute',top:'50%',left:'50%',
    fontWeight:'bold',
    transform:'translate(-50%,-75%)',
  }}>γ</div>
}

const properties = [
    "gamma",
  //"min",:
    //"max",
    "contrast",
    "brightness",
  ]

// Map a value from the range [a,b] to the range [c,d]
function mapValue(value, a, b, c, d) {
  return Number(((value - a) / (b - a)) * (d - c) + c);
}


export default function GlobalChannelSettings({channels, selected: selectedProp,
  disabled,
}){

  const { adjustment={}, setAdjustment } = useContext(FigureChannelAdjustmentContext);


  let channelIds = Object.keys(adjustment)
  let navbarConfig = channelIds.filter(x => {
    if( channelIds.length > 1 ){ 
      return x !== "default"
    }else{
      return true;
    }
  }).map(key=>({_id:key,label:key}));


  let [selected,navbar,setSelected] = useNavbar(
    {options:navbarConfig, debug:true}, 
    navbarConfig[0].label
  )

  if (selectedProp) {
    selected = selectedProp;
  }

  return (

    <div class="">

      {false && <>
      <div>{JSON.stringify(navbarConfig)}</div>

      <div>{JSON.stringify(selected)}</div>
      <div>{navbarConfig[0].label}</div>
      </>}


      {Object.keys(adjustment).length > 1 && selectedProp == null && <div>
        {navbar}
      </div>}



      <table style={{ margin:10 }}>



        {properties.map(property => {

          let inputTypes = [ "range","number" ];

          let title = property[0].toUpperCase() + property.slice(1);
          title = <Tooltip 
            placement={"left"} title={title}>{titleMap[property]}</Tooltip> 
           // || title;




          const padding = 7;


          return (
            <tr>

              <td style={{padding,
                position:'relative',
              }}>{title}</td>

              {inputTypes.map(type => {
                let propMeta = defaults[property] || {};
                let { min=-5, max=5, defaultValue=0, step=0.005 } = propMeta;

                // if( !adjustment[selected] ){
                //   debugger;
                // }

                let value = adjustment?.[selected]?.[property] ?? defaultValue;

                let sliderInfo, mapSlider, invMapSlider;
                if (min < 0) {
                  mapSlider = val => val;
                  invMapSlider = val => val;
                  sliderInfo = { value, min, max, type, step };
                } else {
                  // center at 1
                  mapSlider = val => {
                    if (val < 1) {
                      // map [-(max-1), 1] -> [min, 1]
                      val = mapValue(val, -(max-1), 1, min, 1);
                    }
                    return val;
                  };
                  invMapSlider = val => {
                    if (val < 1) {
                      // map [min, 1] -> [-(max-1), 1]
                      val = mapValue(val, min, 1, -(max-1), 1);
                    }
                    return val;
                  };
                  sliderInfo = { value: invMapSlider(value), min: 1 - max, max, type, step };
                }
                let info = type === 'range' ? sliderInfo : {
                  value,
                  min,
                  max,
                  type,
                  step,

                };

                return (
                  <td style={{padding}}>
                    <input style={{
                      width:'100%',
                      border:'none',
                      borderBottom:'1px solid #ccc',
                    }}
                    onMouseDown={e => {
                      e.stopPropagation();
                    }} 
                    onChange={e => {
                      setAdjustment({
                        ...adjustment,
                        [selected]:{
                          ...adjustment[selected],
                          [property]:mapSlider(e.target.value)
                        }
                      });
                    }} {...info}

                      disabled={disabled}

                    />
                  </td>
                )
              })}

            </tr>
          )
        })}

      </table>



      <div style={{
        //textAlign:'right',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between'
      }} class="full-width">

        <div class="clickable-text round-corners" style={{margin: 10,padding:10,
          background:'#f3f3f3',
        }} onClick={() => {
          setAdjustment({
            ...adjustment,
            [selected]: {
              ...adjustment[selected],
              inverted: !adjustment[selected]?.inverted
            }
          });
        }}>
          Invert Colors
        </div>

        <div class="clickable-text round-corners"
  onClick={e => {
          e.stopPropagation();
          let newAdj = Object.fromEntries(Object.entries(defaults).map(([key,val]) => {
            return [ key, undefined ];//val.defaultValue ];
          }))

          setAdjustment({
            ...adjustment,
            [selected]: { ...adjustment[selected], ...newAdj }
          });

        }} style={{
          margin:10,
          padding:10,
          background:'#f3f3f3',
        }}>Reset</div>
      </div>



      {false && <O>{adjustment}</O>}




    </div>
  )




}
